import VueCompositionAPI from '@vue/composition-api'
import Vue from 'vue'

// Composition API
Vue.use(VueCompositionAPI)
